import { Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputFieldComponent } from '@app/components/input-field/input-field.component';
import { AutoForm } from '@app/interfaces/auto-form.interface';
import { WebhookCreate } from '@app/models/webhook.interface';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-webhook-form',
    imports: [
        ReactiveFormsModule,
        InputFieldComponent,
    ],
    templateUrl: './form.component.html',
    styleUrl: './form.component.scss'
})
export class WebhookFormComponent {
  initialValue = input<WebhookCreate>();
  formChange = output<WebhookCreate>();
  formValid = output<boolean>();

  webhookForm = new FormGroup<AutoForm<WebhookCreate>>({
    provider_id: new FormControl<number>(0, { validators: [Validators.required], nonNullable: true }),
    url: new FormControl<string>('', { validators: [Validators.required], nonNullable: true}),
    sign_secret: new FormControl<string>('', { validators: [Validators.required, Validators.minLength(32), Validators.maxLength(64)], nonNullable: true}),
    processed_sequence_items: new FormControl<boolean>(false, {nonNullable: true}),
    peak_events: new FormControl<boolean>(false, {nonNullable: true}),
    tamper_events: new FormControl<boolean>(false, {nonNullable: true}),
    sequence_events: new FormControl<boolean>(false, {nonNullable: true}),
    sequences: new FormControl<boolean>(false, {nonNullable: true}),
    devices: new FormControl<boolean>(false, {nonNullable: true}),
  });

  constructor() {
    toObservable(this.initialValue).subscribe((initial) => {
      if(initial) {
        Object.keys(initial).forEach(key => {
          // https://stackoverflow.com/a/62438434/3341745
          let prop = key as keyof typeof initial;
          if(initial[prop] != null) {
            this.webhookForm.get(key)?.setValue(initial[prop]);
          }
        });
      }
      this.onChange();
    });
  }

  onChange() {
    this.formValid.emit(this.webhookForm.valid);
    this.formChange.emit(<WebhookCreate>this.webhookForm.value);
  }

}